export const Bio = {
  name: "Usman Mahmood",
  roles: [
    "Senior AI Automation Engineer",
    "End to End AI Solutions Architect",
    "AI Powered Business Automation Specialist",
    "Full Stack AI Engineer with DevOps Expertise",
    "Lead AI Chatbot & Voice Agent Developer",
    "Data Pipeline & ETL Automation Engineer",
    "Enterprise AI Integration Specialist",
    "Generative AI & LLM Implementation Expert",
    "Cloud Native AI Systems Developer",
  ],
  description:
    "A results-driven AI Automation Engineer specializing in architecting and deploying end to end intelligent systems. Expert in Python, FastAPI, and cloud native development, with a focus on building scalable, self learning automation that transforms business workflows. I combine full stack engineering with advanced AI/ML integration to deliver data driven solutions that eliminate manual processes and accelerate revenue outcomes.",
  github: "https://github.com/usmanX191",
  resume:
    "https://drive.google.com/file/d/1hLYh4zw0S5g73MR5xWQXBPnIRGnQyLEK/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/usman-mahmood-1b54851a0/",
  twitter: "https://twitter.com/usmanX191",
  insta: "https://www.instagram.com/usman_x191/",
  facebook: "https://www.facebook.com/usmanmahmmood191/",
};
//Skills
export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/CSS3.png?alt=media&token=6aa5cf84-82f1-40d8-a14b-19af6fd24b9d",
      },
      {
        name: "JavaScript",
        image:
          // "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-javascript%20(1).svg?alt=media&token=53625aab-b650-454a-a72b-99ed928471bc",
      },
      {
        name: "TypeScript",
        image:
          // "https://www.vectorlogo.zone/logos/typescriptlang/typescriptlang-icon.svg",
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-typescript.svg?alt=media&token=3e30f05e-1c43-4fad-92af-bb3623562f9b",
      },
      {
        name: "Material UI",
        image:
          "https://user-images.githubusercontent.com/25181517/189716630-fe6c084c-6c66-43af-aa49-64c8aea4a5c2.png",
      },
      {
        name: "Tailwind CSS",
        image: "https://cdn.worldvectorlogo.com/logos/tailwind-css-2.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node.js",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
      },
      {
        name: "Express.js",
        // image: "https://www.vectorlogo.zone/logos/expressjs/expressjs-icon.svg",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-express-js-40.png?alt=media&token=0d9564fb-1403-4e30-b88f-22ba475e9f33",
      },
      // {
      //   name: "Nest Js",
      //   image: "https://www.vectorlogo.zone/logos/nestjs/nestjs-icon.svg",
      // },
      // {
      //   name: "REST API",
      //   image:
      //     "https://uxwing.com/wp-content/themes/uxwing/download/web-app-development/rest-api-icon.png",
      // },
      {
        name: "GraphQL",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Flask",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-flask-colorful.svg?alt=media&token=e2e6edc3-dad5-49dc-beaf-f5ec38c96e59",
      },
      {
        name: "FastAPI",
        // image: "https://fastapi.tiangolo.com/img/icon-white.svg",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/FastAPI.png?alt=media&token=780ecc59-584f-4280-8c9e-b80659f06675",
      },
      {
        name: "Django",
        image:
          "https://www.vectorlogo.zone/logos/djangoproject/djangoproject-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "PostgreSQL",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "Pinecone",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Pinecone_Logo_1.png?alt=media&token=67af605b-457e-4499-aba6-34dec0f7cd1b",
      },
      {
        name: "Supabase",
        image: "https://www.vectorlogo.zone/logos/supabase/supabase-icon.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Redis",
        image: "https://www.vectorlogo.zone/logos/redis/redis-icon.svg",
      },
    ],
  },
  {
    title: "Cloud / Devops",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Amazon Connect",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Connect.png?alt=media&token=3d2c018c-c3c3-468f-b773-ece7d16039dc",
      },
      {
        name: "Amazon DynamoDB",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/DynamoDB.png?alt=media&token=f34b335f-fad5-4a9f-afa9-bb8b6870fbb2",
      },
      // {
      //   name: "Google Cloud",
      //   image:
      //     "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      // },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Nginx",
        image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      },
      {
        name: "Amazon Kinesis",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Kinesis.png?alt=media&token=21fe8d2f-63a2-46fa-bda1-3198b9a8b528",
      },
      {
        name: "Kinesis Video Streams",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Kinesis%20Video%20Streams.png?alt=media&token=72e3b133-83a0-4c85-aea7-8457fb0cb5e7",
      },
      // {
      //   name: "Terraform",
      //   image:
      //     "https://www.vectorlogo.zone/logos/terraformio/terraformio-icon.svg",
      // },
      {
        name: "Amazon EC2",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/EC2.png?alt=media&token=bd857417-1e2f-4ef1-8997-c5a7501e110d",
      },
      {
        name: "Gitlab CI/CD",
        image: "https://www.vectorlogo.zone/logos/gitlab/gitlab-icon.svg",
      },
      {
        name: "AWS Lambda",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Lambda.png?alt=media&token=ec9c2c08-6597-4962-925d-101b63ef8207",
      },
      {
        name: "AWS Step Functions",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Step%20Functions.png?alt=media&token=9d130b16-e5b1-4d97-bad7-7457eb5e1cc8",
      },
      {
        name: "API Gateway",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/API%20Gateway.png?alt=media&token=af5fb1fb-c935-4c2a-916e-0787686c420a",
      },
      {
        name: "IAM",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Identity%20and%20Access%20Management.png?alt=media&token=b545d055-af07-4cab-9bfe-582166baa3fe",
      },
      {
        name: "CloudWatch",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/CloudWatch.png?alt=media&token=e1b0649d-45d4-45dc-aa42-8231e2e68b82",
      },
      {
        name: "Amazon Redshift",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Redshift.png?alt=media&token=f9312630-fac0-4903-bc12-f516df06ee28",
      },
      {
        name: "SQS",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Simple%20Queue%20Service.png?alt=media&token=86fa1d1b-4b78-4e79-8cee-e2eabc094c7e",
      },
      // {
      //   name: "Grafana",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
      // },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
      {
        name: "Jenkins",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-jenkins.svg?alt=media&token=ac7081e2-1d56-4534-8576-c1654cb559ca",
      },
      {
        name: "Heroku",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-heroku.svg?alt=media&token=de204412-5b92-4a58-9e7f-a7d82816aac9",
      },
      {
        name: "Replit",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-replit-logo-48.svg?alt=media&token=a6198eac-d5a4-4205-992f-54c33f9c07d4",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      // {
      //   name: "Python",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      // },
      {
        name: "Numpy",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/numpy-svgrepo-com.svg?alt=media&token=2e495eee-7594-4649-829c-5d7c7eb6780f",
      },
      {
        name: "Pandas",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/pandas.svg?alt=media&token=2648f66d-a2d1-41eb-9a8a-1be20b49b8c7",
      },
      // {
      //   name: "Keras",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Keras_logo.svg/1200px-Keras_logo.svg.png",
      // },
      {
        name: "PyTorch",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-pytorch.svg?alt=media&token=8badd7ed-2d8f-4fed-8a1b-c631cb0db95e",
      },
      {
        name: "Jupyter Notebook",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-jupyter-96.png?alt=media&token=8e30b97a-cf29-42ba-adfa-cf8ab493bc36",
      },
      {
        name: "Anacoda Mini",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-anaconda-48.png?alt=media&token=2d18907b-b26c-42b7-a8f4-cd48448bd87c",
      },
      {
        name: "AWS Sagemaker",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/SageMaker.png?alt=media&token=fcae2e24-d929-45df-a856-a25cad68b8f8",
      },
      {
        name: "Google Colab",
        image: "https://colab.research.google.com/img/colab_favicon_256px.png",
      },
      {
        name: "LangChain",
        image:
          // "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/langchain.png?alt=media&token=e2d49521-d611-49b4-b8c2-04ac482a6833",
          // "https://ia904609.us.archive.org/3/items/github.com-langchain-ai-langchain_-_2023-10-12_11-59-58/cover.jpg",
          // "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/langchain-icon-white-seeklogo.png?alt=media&token=5fc66e06-d394-461f-a903-d81f793f322c",
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Langchain--Streamline-Simple-Icons.svg?alt=media&token=fbfca4f9-7e9d-4589-bd12-d0f22c1aaa97",
      },
      // {
      //   name: "Matplotlib",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Created_with_Matplotlib-logo.svg/1200px-Created_with_Matplotlib-logo.svg.png",
      // },
      // {
      //   name: "pycharm",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/PyCharm_Icon.svg/1200px-PyCharm_Icon.svg.png",
      // },
      {
        name: "Tenserflow",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/tensorflow/tensorflow-original.svg",
      },
      // {
      //   name: "Scikit Learn",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      // },
    ],
  },
  {
    title: "Automation & Other Tools",
    skills: [
      {
        name: "OPEN AI API",
        image:
          // "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/ChatGPT_logo.svg/1024px-ChatGPT_logo.svg.png",
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-chatgpt.svg?alt=media&token=6be4a5ae-268d-42d5-a20f-cc1f6448e3b6",
      },
      {
        name: "Npm",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/npm-seeklogo.svg?alt=media&token=baf4f323-32dd-41e0-a033-62d2acb410c1",
      },
      {
        name: "Yarn",
        image: "https://www.vectorlogo.zone/logos/yarnpkg/yarnpkg-icon.svg",
      },
      {
        name: "Pip",
        image: "https://www.vectorlogo.zone/logos/pypi/pypi-icon.svg",
      },
      {
        name: "Git",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-git.svg?alt=media&token=cc19536a-db3e-4519-98b4-5ed836e0d5e1",
      },
      {
        name: "GitHub Actions",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-github%20(1).svg?alt=media&token=cd3bd5d3-eb77-4824-aaec-6a8118e69b70",
      },
      // {
      //   name: "Netlify",
      //   image:
      //     "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      // },
      {
        name: "Vercel",
        image: "https://www.vectorlogo.zone/logos/vercel/vercel-icon.svg",
      },
      {
        name: "N8N",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/n8n-color.svg?alt=media&token=d0da5d9d-5a7e-4963-bca1-385fa25b1b82",
      },
      {
        name: "Tableau",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-tableau-software.svg?alt=media&token=fb9293c5-3e11-4d59-8986-06347f91bf94",
      },
      {
        name: "Power BI",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-power-bi-2021.svg?alt=media&token=e60c79b8-5faf-4432-bb6f-6a09388202ad",
      },
      // {
      //   name: "Postman",
      //   image:
      //     "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      // },
      {
        name: "ManyChat",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/manychat.svg?alt=media&token=6d670fed-08e8-4546-94e5-93e85a376bab",
      },
      {
        name: "Pipedream",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/p.png?alt=media&token=cf48252e-e2bb-4c56-a43f-3b63fa053942",
      },
      {
        name: "HubSpot",
        image: "https://www.vectorlogo.zone/logos/hubspot/hubspot-icon.svg",
      },
      {
        name: "Salesforce",
        image:
          "https://www.vectorlogo.zone/logos/salesforce/salesforce-icon.svg",
      },
      {
        name: "GoHighLevel",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/highlevel.png?alt=media&token=659a03ef-1b8e-4d35-8945-cc54a6e319f3",
      },
      {
        name: "Zoho CRM",
        image: "https://www.vectorlogo.zone/logos/zoho/zoho-icon.svg",
      },
      {
        name: "Apollo.io",
        image: "https://www.vectorlogo.zone/logos/apolloio/apolloio-icon.svg",
      },
      {
        name: "Stripe",
        image: "https://www.vectorlogo.zone/logos/stripe/stripe-icon.svg",
      },
      {
        name: "Twilio",
        image: "https://www.vectorlogo.zone/logos/twilio/twilio-icon.svg",
      },
      {
        name: "SendGrid",
        image: "https://www.vectorlogo.zone/logos/sendgrid/sendgrid-icon.svg",
      },
      {
        name: "Slack API",
        image: "https://www.vectorlogo.zone/logos/slack/slack-icon.svg",
      },
      {
        name: "Trello API",
        image: "https://www.vectorlogo.zone/logos/trello/trello-icon.svg",
      },
      {
        name: "Whatsapp API",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
      },
      {
        name: "Zoom API",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Zoom.png?alt=media&token=acb5f858-5217-4835-8523-65722d461890",
      },
      {
        name: "Clickup API",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Clickup.svg?alt=media&token=2082677e-a3c5-426d-8154-3d3cd16c3682",
      },
      {
        name: "Make.com",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/make-color.svg?alt=media&token=0e549496-e98a-4a09-9c8d-32502018e276",
      },
      {
        name: "Microsoft Power Platform",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/microsoft-power-platform-seeklogo.png?alt=media&token=632040d4-13ac-4924-a3c3-0475b2f95310",
      },
      {
        name: "Microsoft Power Automate",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/microsoft-power-automate-seeklogo.png?alt=media&token=9b1df79d-dd32-43de-8ba1-095e509fed01",
      },
      {
        name: "OpenClaw",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/openclaw-seeklogo.png?alt=media&token=9779f830-e781-4e8c-950e-bab66dde1ce6",
      },
      {
        name: "Copilot Studio",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/copilot-icon.png?alt=media&token=2c50bdca-e3c0-457b-b783-9849af8f9188",
      },
      {
        name: "Microsoft Power Apps",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/icons8-microsoft-power-apps-80.png?alt=media&token=86d5de39-130c-41c2-8824-92b307ee6137",
      },
      {
        name: "Azure Logic Apps",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/logic-apps.png?alt=media&token=1e2fecdb-7128-4ce9-a987-79c11664f345",
      },
      {
        name: "Google Veo 3.1 API",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Google-Veo-3-Logo-PNG.png?alt=media&token=030b28ed-ec90-4f28-8ca5-208301e8c3f3",
      },
      {
        name: "Sora 2 API",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/OpenAI_Symbol_1.png?alt=media&token=923cee6f-664e-4bc5-b6d7-e444366e1978",
      },
      {
        name: "Elevenlabs",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/elevenlabs.svg?alt=media&token=5e4f44b4-678a-4a5e-9867-9fd2afbb6f56",
      },
      {
        name: "Vapi",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/va-square-1.png?alt=media&token=02df77ac-584a-400a-ab7c-fcc8405b772d",
      },
      {
        name: "Airtable",
        image: "https://www.vectorlogo.zone/logos/airtable/airtable-icon.svg",
      },
      {
        name: "Apify",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Apify_apify-symbol-safe_1.png?alt=media&token=7946bfc9-4593-4b6d-a22c-fdafca3947e9",
      },
      {
        name: "BigQuery",
        image:
          "https://www.vectorlogo.zone/logos/google_bigquery/google_bigquery-icon.svg",
      },
      {
        name: "Claude",
        image:
          "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Claude_Logo_1.png?alt=media&token=0ba5f60c-0fa6-4e7e-80c2-dd80e7e6e004",
      },
    ],
  },
];

export const experiences = [
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/premier_nx_logo.jpg?alt=media&token=c0f8b2d8-a1d7-4252-befb-37735f55ebf1",
    role: "AI Engineer",
    company: "Premier NX",
    date: "Feb 2026 - Present",
    desc: "Design and deploy production-grade enterprise AI systems specializing in conversational voice agents on Amazon Connect using Nova Sonic, Q in Connect, and Bedrock AgentCore Gateway. Build custom Model Context Protocol (MCP) servers integrating AWS Lambda, external APIs, and RAG knowledge bases (AWS Bedrock with S3 vectors) for real-time, uninterrupted multi-agent orchestration and live data retrieval within a single voice session. Across AWS and Azure, create end-to-end intelligent automation pipelines that embed RAG-powered decision engines into Power Apps, Power Automate, and Logic Apps, unifying enterprise data sources and enabling scalable, production-ready workflows for complex business decision-making.",
    skills: [
      "Amazon Bedrock",
      "AWS Bedrock AgentCore Gateway",
      "Amazon Q",
      "Q in Connect",
      "Nova Sonic",
      "AWS Connect",
      "AWS SageMaker",
      "AWS Lambda",
      "AWS Step Functions",
      "AWS EC2",
      "Amazon S3 Vector Databases",
      "Kinesis Video Streams",
      "Docker",
      "Model Context Protocol (MCP)",
      "RAG",
      "Azure Logic Apps",
      "Azure Functions",
      "Microsoft Power Platform",
      "Microsoft Power Apps",
      "Microsoft Power Automate"
    ]
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/get_ai_chatbots_logo.jpeg?alt=media&token=6138691f-a52a-4000-a257-d15e755c1572",
    role: "AI Automation Engineer",
    company: "GetAiChatbots LLC",
    date: "Dec 2024 - Feb 2026",
    desc: "At GetAiChatbots LLC, I architected and deployed end to end AI automation solutions that eliminate manual workflows and accelerate business outcomes. I built multi channel lead conversion systems, voice AI agents, and intelligent chatbot platforms using Python, FastAPI, n8n, LangChain, and OpenAI, with self learning pipelines for sentiment analysis and real time optimization. I also integrated complex ecosystems including Apollo.io, GoHighLevel, HubSpot, Salesforce, Zoho, Twilio, Vapi, ElevenLabs, and Stripe across AWS and Azure, while automating web scraping with Beautiful Soup, Playwright, and Scrapy for large scale datasets.",
    skills: [
      "Python",
      "FastAPI",
      "n8n",
      "LangChain",
      "OpenAI API",
      "AWS",
      "Azure",
      "Apollo.io",
      "GoHighLevel",
      "HubSpot",
      "Salesforce",
      "Zoho",
      "Twilio",
      "ElevenLabs",
      "Stripe",
      "Beautiful Soup",
      "Playwright",
      "Scrapy",
      "Data Pipelines",
      "Lead Conversion",
      "AI Automation",
      "Chatbot Development",
      "Real-Time Optimization",
    ],
    //doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/moonsys.jpg?alt=media&token=18a9e10e-074c-444e-b3e3-fa94b4d181fb",
    role: "Software Engineer",
    company: "Moonsys Pvt. Ltd.",
    date: "Jan 2024 - Dec 2024",
    desc: "Moonsys Pvt. Ltd. is a USA based software startup specializing in generative AI, software development, and related technologies. They provide innovative solutions to meet the evolving needs of their clients in the digital landscape. At Moonsys, I led the development of the GPT Translator project, utilizing OPEN-AI and Adobe API's to create a powerful translation platform. Leveraging Express.js, I orchestrated the backend development and deployed the solution on AWS infrastructure. This project honed my skills in API integration, backend development, and cloud deployment, demonstrating my ability to deliver efficient and scalable solutions.",
    skills: [
      "AWS",
      "EC2",
      "S3",
      "Lambda",
      "OpenAI API",
      "Adobe API",
      "API Gateway",
      "API Integration",
      "Dockers",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "Express Js",
      "OAuth 2.0",
      "MongoDB",
      "Next Js",
      "React Js",
      "Ngrok",
    ],
    //doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/codebryx.jpg?alt=media&token=1fc14627-6956-4bc5-a642-d86b7815ae98",
    role: "Software Engineering Intern",
    company: "CodeBryx Technologies Pvt. Ltd.",
    date: "oct 2023 - Dec 2023",
    desc: "I did an Intership during my last semester at CodeBryx. Where I Enhanced user experiences on CodeBryx PSG & Hybrid, Portals by resolving bugs & reduced load time by 40%. Built CodeBryx Analytics portal using React Js with seamless interaction of REST APIs using AXIOS optimized with React Query. Refactored previous code to TypeScript, updated with new dependency and integrated Vite with Jest for Unit Testing.",
    skills: [
      "ReactJS",
      "NextJs",
      "Redux Toolkit",
      "Material UI",
      "Tailwind CSS",
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "Express Js",
      "MongoDB",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  // {
  //   id: 2,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
  //   role: "Android Developer Intern",
  //   company: "Rudraksha Welffare Foundation",
  //   date: "June 2021 - Oct 2021",
  //   desc: "• Built RudraShakti - Astrologer App, with MVVM Architecture using Java and Android Studio integrating Firebase SDK. Created One to One video call integration with Socket.IO and Firebase cloud functions and integrated with Retrofit. Created Low Level Design and converted Figma design to XML code.",
  //   skills: [
  //     "Android",
  //     "Java",
  //     "Kotlin",
  //     "XML",
  //     "Node Js",
  //     "Cloud Firestore",
  //     "Firebase",
  //     "Figma",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  // },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/skyscanner.jpg?alt=media&token=ff81c515-612b-42b4-90cb-1a9ffb8041a5",
    role: "Frontend Developer Intern",
    company: "Skyscanner Pvt. Ltd.",
    date: "April 2023 - May 2023",
    desc: "I built a web application using React as a front end engineer at Skyscanner. Developed a page for picking a travel date using Skyscanner’s open source Backpack React library. Customised my application and ran automated tests to ensure it rendered properly.",
    skills: [
      "ReactJS",
      "NextJs",
      "Redux",
      "Redux Toolkit",
      "Material UI",
      "Tailwind CSS",
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "Vite",
      "Jest",
      "React Query",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/SKYSCANNER%20FRONT-END%20DEVELOPER%20INTERN.png?alt=media&token=64a0578f-430b-47b2-aa66-41b7f58e9506",
  },
];

export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/ucp.jpg?alt=media&token=9e3315f8-af5f-4064-880c-e8a9ae9c0778",
    //img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Kiit.jpeg?alt=media&token=3839d520-c59d-4341-ad8f-0980c98de4dd",
    school: "University of Central Punjab, Lahore, Pakistan",
    date: "Feb 2019 - Aug 2023",
    //grade: "3.7/4 CGPA",
    desc: "I graduated with a Bachelor of Science (Honors) in Software Engineering from the University of Central Punjab in Lahore, Pakistan, where I studied from February 2019 to August 2023. My curriculum was comprehensive and challenging, encompassing key courses such as Object Oriented Programming, Data Structures and Algorithms, Database Management Systems, Software Quality Assurance, and Machine Learning. These courses, among others, have equipped me with a robust foundation in software development principles and practices, preparing me for a dynamic career in the technology sector.",
    degree: "Bachelor of Science - Bsc.Hons, Software Engineering",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/pgc.jpg?alt=media&token=5217bba8-cccc-4291-bac8-3b8a57dd26cb",
    school: "Punjab Group of Colleges, Lahore, Pakistan",
    date: "Sept 2016 - Sept 2018",
    //grade: "86.2%",
    desc: "From September 2016 to September 2018, I attended PGC, where I pursued the FSC Pre Engineering Intermediate degree(XII). My focus was on the core subjects of Chemistry, Physics, and Mathematics which results in reflecting my strong grasp in the scientific principles and my dedication to the field of engineering.",
    degree:
      "FSC(XII), Pre-Engineering with Chemistry, Physics, and Mathematics",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/educators.jpg?alt=media&token=0edeb242-63f3-4b3b-bac2-2d6dd2b59a24",
    school: "The Educators School, Lahore, Pakistan",
    date: "March 2014 - March 2016",
    //grade: "90.5%",
    desc: "From March 2014 to March 2016, I pursued my Matriculation(X) in Science with Computer Applications at The Educators School, Lahore. The program effectively blended theoretical science with practical computing, setting a strong groundwork for further technological and scientific education.",
    degree: "Matriculation(X), Science with Computer Application",
  },
];

export const projects = [
  {
    id: 11,
    title: "GPT Translator",
    date: "Jan 2024 - June 2024",
    description:
      "I developed the GPT Translator web app, managing both frontend and backend components. Integrated with the OpenAI API, it translates user entered text and various document formats (PDF, Excel, PPTX, DOCX) into multiple languages. The app provides context based translations for enhanced comprehension. I led the project, utilizing OpenAI and Adobe APIs, orchestrated backend development with Express.js, and deployed it on AWS. This experience refined my skills in API integration, backend development, and cloud deployment.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Screenshot%202025-12-20%20060825.png?alt=media&token=eee2a60e-1cdc-4d65-889d-fcbc058cb67c",
    tags: [
      // "AWS",
      // "EC2",
      "S3 Bucket",
      // "Lambda",
      "OpenAI API",
      "API Gateway",
      "Adobe API",
      "TypeScript",
      "Node Js",
      "Express Js",
      "Google OAuth 2.0",
      "Microsoft OAuth 2.0",
      "MongoDB",
      "Next Js",
      "SaaS Product",
    ],
    category: ["web app", "SaaS Product"],
    github: "https://www.gpttranslator.co/",
    webapp: "https://www.gpttranslator.co/",
  },
  {
    id: 11,
    title: "Levate.ai Comprehensive Business Management Platform",
    date: "March 2024 - April 2024",
    description:
      "Levate.ai is a sophisticated business management platform designed to streamline operational efficiency and data handling. I developed the core frontend and backend components, implementing robust CRUD operations and a secure authentication system (login, signup, and password recovery). The platform features an intuitive dashboard that visualizes key financial metrics including total, pre booking, and post booking revenue through dynamic graphs. Additionally, I built a versatile ticketing system for task management and customer support, alongside editable user profiles. To support the platform's data driven capabilities, I managed seamless interactions with a MySQL database, ensuring optimal data flow for the client’s integrated machine learning algorithms.",
    image: [
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/levate.png?alt=media&token=1e411c04-df83-4cf2-8a07-75b368f32189",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Levate%20AI%20(9).jpg?alt=media&token=23086d44-7d4e-45ca-9fde-e6d56d469efa",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Levate%20AI%20(10).jpg?alt=media&token=f08e3e29-df5f-406c-b778-044100ec0ce3",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Levate%20AI%20(6).jpg?alt=media&token=6a0a5856-7aac-4ede-bb17-557b4177dcb0",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Levate%20AI%20(7).jpg?alt=media&token=6e767f5a-0f1e-4c13-9d2a-d8399d070651",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Levate%20AI%20(8).jpg?alt=media&token=fcde6ac3-da53-4393-ba63-00aaa8343276",
    ],
    tags: [
      "FastAPI",
      "MySQL",
      "SQLAlchemy",
      "Alembic",
      "Pydantic",
      "Python",
      "Next Js",
      "MVP",
    ],
    category: ["web app", "MVP Project"],
    github: "https://levate-frontend.vercel.app/",
    webapp: "https://levate-frontend.vercel.app/",
  },
  {
    id: 1,
    title: "ADF Sales & Marketing Bot (Creative Marketer AI)",
    date: "Feb 2025 - March 2025",
    description:
      "Built Creative Marketer AI for ADF, leveraging the OpenAI Assistant API to automate customer interactions, lead generation, and marketing campaigns. Integrated with HubSpot CRM for sales tracking and Stripe API for payments. Developed using FastAPI, React.js, and PostgreSQL, and deployed on Replit, enhancing customer engagement and boosting conversions.",
    image: [
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Screenshot%202025-03-11%20175636.png?alt=media&token=5c2e5e0f-2264-4f24-8c4d-50d4dda4f0e5",
    ],
    tags: [
      "OpenAI Assistant API",
      "Python",
      "FastAPI",
      "Stripe API",
      "PostgreSQL",
      "Replit",
      "Sales Automation",
      "Marketing Automation",
      "Hubspot CRM Integration",
      "MVP",
    ],
    category: ["AI Automation", "MVP Project"],
    github: "https://adf-creative-marketer-ai-assistant-frontend.replit.app/",
    webapp: "https://adf-creative-marketer-ai-assistant-frontend.replit.app/",
  },
  {
    id: 6,
    title: "Cypto Tracker",
    date: "Sep 2023 - Oct 2023",
    description:
      "The React.js Crypto Tracker is an interactive web application designed to provide crypto enthusiasts with real-time and historical cryptocurrency data, supporting price trends analysis in PKR, INR, and USD across various time frames, enhanced with Chart.js visualizations and Material-UI.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/crypto-tracker-2.png?alt=media&token=8749e420-eafd-4073-918c-a3be629520f1",
    tags: [
      "JavaScript",
      "React Js",
      "Chart Js",
      "Rest-API",
      "Context-API",
      "Axios",
      "Material-UI",
    ],
    category: "web app",
    github: "https://github.com/usmanX191/React-Crypto-Tracker",
    webapp: "https://react-crypto-tracker-website.netlify.app",
  },
  {
    id: 2,
    title: "AI-Powered Lead Generation System",
    date: "April 2025",
    description:
      "Fully autonomous lead lifecycle management system leveraging emotional intelligence and dynamic optimization. Features intelligent lead sourcing via Apify and Apollo.io, advanced CRM segmentation.",
    image: [
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Lead%20Generation%20(5).png?alt=media&token=d78acbb4-0516-4baf-ad6c-8e80559535dd",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Lead%20Generation%20(2).png?alt=media&token=521a04c6-fb76-4280-9eeb-e362d4ed25fa",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Lead%20Generation%20(1).png?alt=media&token=0019b93f-e707-42a1-8d66-e1a437f8e558",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Lead%20Generation%20(3).png?alt=media&token=50544fe6-3ebc-4054-93fb-5ef421da5967",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Lead%20Generation%20(4).png?alt=media&token=69117250-48fe-4991-a74e-b02152f9bd39",
    ],
    tags: ["N8N", "Apollo.io API", "Apify", "Airtable", "OpenAI GPT-4.1"],
    category: "AI Automation",
    github: "",
    webapp: "",
  },
  {
    id: 3,
    title: "Hi-ROOTS Real Estate Business Automation Workflow",
    date: "July 2025 - August 2025",
    description:
      "End-to-end rental property management automation orchestrating complete tenant journey. Features multi-channel lead capture with AI-powered scoring, intelligent communication engine, automated appointment management, application processing with document tracking, contract generation with e-signatures, lifecycle management with maintenance routing, lease renewal automation, and comprehensive analytics dashboards.",
    image: [
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/HRREA%20(4).png?alt=media&token=8ec38c64-cbf9-4ba1-ae45-0bc434968fa8",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/HRREA%20(3).png?alt=media&token=5b0eac38-0e66-4997-9cf6-34a8d9622ce9",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/HRREA%20(5).png?alt=media&token=89724b1d-6691-47fd-8ad8-19323e69249a",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/HRREA%20(2).png?alt=media&token=9333b05c-70a1-4a8b-a90c-1135957adc1c",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/HRREA%20(1).png?alt=media&token=25bdbc83-6001-4413-b41c-317d78aa6920",
    ],
    tags: [
      "N8N",
      "SendGrid",
      "Twilio",
      "Go High Level",
      "Gmail",
      "OpenAI GPT-4",
      "OpenAI GPT-5",
      "MCP Server",
      "Airtable",
      "Google Sheets",
    ],
    category: "AI Automation",
    github: "",
    webapp: "",
  },
  // {
  //   id: 4,
  //   title: "Automated Zoom Meeting Processing & Archiving System",
  //   date: "May 2025",
  //   description: "Automated post-meeting workflow for intelligent recording management and contact-based archiving. Webhook-triggered system automatically downloads MP4 recordings and VTT transcripts upon meeting completion, verifies contacts in Zoho CRM, creates dynamic Google Drive folders with meeting metadata, and organizes files under corresponding contact folders for zero-touch file management.",
  //   image: "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Screenshot%202025-12-28%20203258.png?alt=media&token=d0e47cf3-aaf8-4d0f-a498-6f24fa09f7dc",
  //   tags: [
  //     "N8N",
  //     "Zoom API",
  //     "Google Drive API",
  //     "Zoho CRM",
  //     "Webhooks"
  //   ],
  //   category: "AI Automation",
  //   github: "",
  //   webapp: ""
  // },
  // {
  //   id: 7,
  //   title: "Multi-Function Telegram Business Assistant",
  //   date: "2024",
  //   description: "Versatile conversational AI assistant for construction/manufacturing/materials supply business enabling natural language operations via Telegram. Features contact management through GHL CRM, Google Calendar appointment operations, real-time materials inventory tracking, Google Drive document management, OpenAI Whisper voice transcription, and LangChain agent for intelligent multi-tool routing.",
  //   image: "",
  //   tags: [
  //     "N8N",
  //     "Telegram Bot API",
  //     "OpenAI GPT-4.1-mini",
  //     "LangChain Agent",
  //     "MCP Client",
  //     "Google Sheets API",
  //     "Google Calendar API",
  //     "Google Drive API",
  //     "Go High Level CRM API",
  //     "OpenAI Whisper"
  //   ],
  //   category: "AI Automation",
  //   github: "",
  //   webapp: ""
  // },
  // {
  //   id: 8,
  //   title: "Stratbot - Strategic AI Consulting Assistant",
  //   date: "2024",
  //   description: "Internal AI consulting system providing strategic advice, design guidance, and implementation help for AI automation projects. Features conversational interface with Pinecone RAG searching indexed documentation, PostgreSQL chat memory for context persistence, and automated knowledge base builder that processes Google Drive documentation and maintains searchable vector store for expert-level guidance.",
  //   image: "",
  //   tags: [
  //     "N8N",
  //     "OpenAI GPT-4.1-mini",
  //     "LangChain Conversational Agent",
  //     "Pinecone",
  //     "PostgreSQL",
  //     "OpenAI Embeddings",
  //     "Google Sheets API",
  //     "Google Drive API"
  //   ],
  //   category: "AI Automation",
  //   github: "",
  //   webapp: ""
  // },
  {
    id: 9,
    title: "Share The Truth - Endorsements Outreach Automation",
    date: "Aug 2025 - Sep 2025",
    description:
      "Advanced automated outreach system for securing testimonials and endorsements through AI-driven lead generation. Features AI-powered prospect identification via Gemini and Perplexity APIs, email validation and enrichment, hyper-personalized email composition with A/B testing, custom MCP server for reply analysis with sentiment detection, and self-improving system with continuous optimization.",
    image: [
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/STT%201.png?alt=media&token=7ca7cca2-8df1-423e-8a12-7e514b0e71e7",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/STT%202.png?alt=media&token=5e4abd97-317e-4df7-a281-28bc126a9b2b",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/STT%203.png?alt=media&token=ec1d1bc5-902e-4d5b-8453-f29dc8ac849e",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/STT%204.png?alt=media&token=790e82ec-9b51-4b3d-ba27-22b8325172d9",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/STT%205.png?alt=media&token=0b3bfb3d-81f2-4369-9df8-e0250622e7b2",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/STT%206.png?alt=media&token=8510a3d9-e18a-4ad0-babd-f3fad9fcf5e5",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/STT%207.png?alt=media&token=3970a3ee-9820-4df4-914d-ed77fa1447fc",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/STT%208.png?alt=media&token=4327ffaa-8fd5-45e5-8663-f1798321b9cd",
    ],
    tags: [
      "N8N",
      "HubSpot",
      "HubSpot API",
      "HubSpot CRM",
      "Google Sheets",
      "Gemini API",
      "Perplexity API",
      "OpenAI GPT-5",
      "Grok",
      "SendGrid",
      "Linkup.so",
      "MCP Server",
      "A/B Testing",
    ],
    category: "AI Automation",
    github: "",
    webapp: "",
  },
  {
    id: 10,
    title: "AI-Powered Viral Video Generation & Distribution System",
    date: "October 2025",
    description:
      "End-to-end automation for AI-generated video content creation and multi-platform social media distribution. Features custom AI agent for content ideation with trend analysis, cinematic scene prompt generation, Sora-2 text-to-video production with parallel sound effects via FAL.ai, automated video composition using FFMPEG, AI-generated viral captions and hashtags, and Blotato integration for simultaneous TikTok/YouTube/Instagram publishing.",
    image: [
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/SMC%203.png?alt=media&token=d248fdf7-eafa-4bf7-a3c1-daedb469bb1a",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/SMC%202.png?alt=media&token=acd4ede9-9eeb-4fcc-bcb6-acd979e0d6e5",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/SMC%201.png?alt=media&token=6a72e373-9db1-4c23-973f-a713c8c3cf7e",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/VideoFile-video_68ffd40623888191a03a9fcc48eda32201e4106579e088f4_video.mp4?alt=media&token=d5c77d99-8b91-46a1-8f6e-92d78038e402",
    ],
    tags: [
      "N8N",
      "Sora-2",
      "Veo 3.1",
      "Wavespeed",
      "FAL.ai",
      "MMAudio",
      "FFMPEG",
      "Blotato",
      "Google Sheets",
      "OpenAI",
    ],
    category: "AI Automation",
    github: "",
    webapp: "",
  },
  {
    id: 11,
    title: "Automated Chef Recruitment & Onboarding Funnel",
    date: "July 2025",
    description:
      "Complete automation of temporary chef applicant onboarding from screening through certification validation. Features VAPI voice agent powered by Twilio for screening calls, automated application workflow with tracking, certification process guidance with email links, Mistral AI OCR for certificate validation extracting applicant details, and automated status updates with follow-ups for missing documents.",
    image: [
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/TCP%20(4).png?alt=media&token=a598e05c-ada3-4e36-9fb8-5b8c40bda3a3",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/TCP%20(5).png?alt=media&token=3640438c-09ae-493e-a121-7d2540bd639d",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/TCP%20(3).png?alt=media&token=c1f5e430-d3b5-4686-aac2-7371f1581148",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/TCP%20(2).png?alt=media&token=d32e27e7-4196-4784-b712-4d39249855f7",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/TCP%20(1).png?alt=media&token=eb0b26e2-617f-471b-8bab-c5efc938d155",
    ],
    tags: [
      "N8N",
      "N8N Forms",
      "VAPI",
      "Twilio",
      "Google Sheets",
      "Gmail",
      "Mistral AI",
      "OCR",
    ],
    category: "AI Automation",
    github: "",
    webapp: "",
  },
  // {
  //   id: 12,
  //   title: "Static WhatsApp Pharmacy Onboarding & Verification System",
  //   date: "2024",
  //   description: "Rule-based WhatsApp system for prescription intake and customer verification at pharmacy. Features static bot with guided customer data collection and prescription photo submission, dual staff notification via WhatsApp and Gmail, custom Replit web verification interface with phone-based search and unique identifier assignment, and automated customer confirmation workflow with complete audit trail.",
  //   image: "",
  //   tags: [
  //     "N8N",
  //     "WhatsApp Business API",
  //     "WAAPI",
  //     "Google Sheets",
  //     "Gmail",
  //     "Replit",
  //     "Node.js",
  //     "Express.js"
  //   ],
  //   category: "AI Automation",
  //   github: "",
  //   webapp: ""
  // },
  {
    id: 13,
    title: "CopeCart Intelligent Lead Qualification System",
    date: "Nov 2025 - Dec 2025",
    description:
      "Enterprise-level AI-driven sales automation managing complete customer acquisition journey for coaches and course creators. Features interactive landing page with revenue calculator and progressive HubSpot forms, AI SMS sales agent with GPT-4 providing 2-5 minute engagement and intelligent routing, 16-stage HubSpot deal pipeline orchestration, advanced abandonment recovery and nurture sequences, TCPA compliance handling, and real-time analytics dashboards.",
    image: [
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/CC%20(2).png?alt=media&token=14e37e26-ba36-43ee-a5a8-731ef17c7e1d",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/CC%20(3).png?alt=media&token=461b0752-8c33-4deb-ab60-654d97a4399f",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/CC%20(4).png?alt=media&token=a2112c41-fa74-45b3-825e-7def2f0fe0b3",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/CC%20(5).png?alt=media&token=92577129-c57d-4d20-ad29-5b5592f53e84",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/CC%20(6).png?alt=media&token=1c6f3bdc-3d2c-4bb3-a685-42018306afd9",
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/CC%20(7).png?alt=media&token=bdab2288-fa51-44da-bcb3-fc9ab1a082c0",
    ],
    tags: [
      "HubSpot CRM",
      "HubSpot Marketing Enterprise",
      "HubSpot Operations Hub",
      "N8N",
      "Sakari SMS API",
      "OpenAI GPT-5.2",
      "ClickFunnels",
      "Slack API",
      "JavaScript",
    ],
    category: "AI Automation",
    github: "",
    webapp: "",
  },
  // {
  //   id: 0,
  //   title: "Podstream",
  //   date: "Apr 2023 - May 2023",
  //   description:
  //     "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
  //   tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Podstream",
  //   webapp: "https://podstream.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  // {
  //   id: 1,
  //   title: "Vexa",
  //   date: "Oct 2022 - Jan 2023",
  //   description:
  //     "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
  //   tags: [
  //     "React Js",
  //     "MongoDb",
  //     "Node Js",
  //     "Express Js",
  //     "Redux",
  //     "NodeMailer",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Project-Management-App",
  //   webapp: "https://vexa-app.netlify.app/",
  // },
  // {
  //   id: 3,
  //   title: "Buckoid",
  //   date: "Dec 2021 - Apr 2022",
  //   description:
  //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
  //   image:
  //     "https://camo.githubusercontent.com/3ad28aa710d18525f1fc87de056ed53c706d09979589bfd5a773df36653bad38/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
  //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
  //   category: "mobile app",
  //   github: "https://github.com/rishavchanda/Buckoid-Android-App",
  //   webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  // },
  // {
  //   id: 10,
  //   title: "Job Finding App",
  //   date: "Jun 2023 - Jul 2023",
  //   description:
  //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
  //   tags: ["React Native", "JavaScript", "Axios"],
  //   category: "mobile app",
  //   github: "https://github.com/rishavchanda/Job-finder-App",
  //   webapp: "https://github.com/rishavchanda/Job-finder-App",
  // },
  // {
  //   id: 4,
  //   title: "Whatsapp Clone",
  //   date: "Jul 2021",
  //   description:
  //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
  //   image:
  //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
  //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
  //   webapp: "https://whatsapp-clone-rishav.web.app",
  // },
  // {
  //   id: 5,
  //   title: "Todo Web App",
  //   date: "Jun 2021",
  //   description:
  //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   image:
  //     "https://camo.githubusercontent.com/84ac6ab6f378348ef28d8184062b7e9e3511a1252ae3966eaa49e8e998f732a7/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  // },
  // {
  //   id: 6,
  //   title: "Breaking Bad",
  //   date: "Jun 2021",
  //   description:
  //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
  //   image:
  //     "https://camo.githubusercontent.com/937774368308a82419f53dd6eeb4a8675780e119636488b4e3cfe5d34859a72a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
  //   tags: ["React Js", "API", "Axios", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Breaking-Bad",
  //   webapp: "https://breaking-bad-webapp.netlify.app",
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "mobile app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  {
    id: 8,
    title: "Real-Estate-Data-Streaming-Pipeline-Project",
    date: "Sept 2024 - Oct 2024",
    description:
      "An End-to-End Real Estate Data Streaming & Analytics Pipeline built with a variety of technologies, including Python, Open-AI Api, Bright Data, Apache Kafka, Apache Spark, Cassandra, and Power BI. The pipeline is designed to extract real-time property data, process it efficiently, store large datasets, and visualize key insights for market analysis.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Real-Estate-Data-Streaming-Pipeline-Project.jpeg?alt=media&token=fde712e5-92c1-4cef-ae93-32ed5e320952",
    tags: [
      "Python",
      "Open-AI API",
      "Bright Data",
      "Beautifull Soup",
      "Apache Kafka",
      "Zookeeper",
      "Apache Spark",
      "Cassandra",
      "DBeaver",
      "Power BI",
    ],
    category: "data engineering & analytics",
    github:
      "https://github.com/usmanX191/Real-Estate-Data-Streaming-Pipeline-Project",
    webapp:
      "https://github.com/usmanX191/Real-Estate-Data-Streaming-Pipeline-Project",
  },
  {
    id: 7,
    title: "House Movers",
    date: "May 2023 - July 2023",
    description:
      "A house movers mobile application built on react native expo facilitates easy hiring of individuals or organizations for seamless household relocation. Leveraging AI-powered sentiment analysis, it ensures top-notch service quality based on user feedback. Features include item packing, transportation, destination setup, and real-time transporter tracking for enhanced customer satisfaction.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/house-movers.png?alt=media&token=528c281f-534b-4b2f-86bf-9bdfb8b6b00a",
    tags: [
      "JavaScript",
      "Python",
      "React Native Expo",
      "MongoDb",
      "Google Map Api",
      "Node Js",
      "Express Js",
      "NLP",
      "Sentiment Analysis",
    ],
    category: "mobile app",
    github: "https://github.com/usmanX191/REACT-NATIVE-HOUSE-MOVERS-APP",
    webapp: "https://github.com/usmanX191/REACT-NATIVE-HOUSE-MOVERS-APP",
  },
  {
    id: 2,
    title: "Brain Tumor Detection",
    date: "Dec 2023 - Feb 2024",
    description:
      "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    image:
      "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "https://github.com/usmanX191/Brain-Tumor-Detection",
    webapp: "https://brain-tumor.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 9,
    title: "Trackify",
    date: "Oct 2023 - Feb 2024",
    description:
      "Trackify is a web application designed to streamline task management and enhance productivity in the workplace. It provides a user-friendly interface for employers to keep track of their employees' daily work activities and empowers employees to log their tasks efficiently. \nAdmin Credentials: # Email: testadmin@gmail.com #Password- 123@testadmin, Employee Credentials:	#Email: testemployee@gmail.com	#Password- 123@Testemployee",
    image:
      "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
    tags: [
      "Docker",
      "AWS",
      "DuckDNS",
      "Eslint",
      "Husky",
      "CI/CD",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
    ],
    category: "web app",
    github: "https://github.com/usmanX191/Trackify-WebApp",
    webapp: "https://trackify-management.netlify.app/",
  },
  {
    id: 3,
    title: "Book Recommendation System",
    date: "Nov 2024 - Dec 2024",
    description:
      "This project is a book recommendation system that leverages the Google Books API to recommend books based on user preferences such as genre, author, or keywords. It features a backend service built with FastAPI and a frontend interface developed using Streamlit for interactive user input. Additionally, it incorporates the OpenAI AI Assistant API to assist with user queries, providing an AI-powered chatbot experience for enhanced user interaction and personalized recommendations.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/book-recommendation-system.png?alt=media&token=ffeeb461-cd38-4b26-963d-536e3fb24397",
    tags: [
      "FastAPI",
      "Streamlit",
      "Python",
      "Rest-API",
      "OpenAI API",
      "OpenAI Assistant API",
      "Google Books API",
    ],
    category: "AI Automation",
    github: "https://github.com/usmanX191/Book-Recommendation-System",
    webapp: "https://github.com/usmanX191/Book-Recommendation-System",
  },
  {
    id: 40,
    title: "Global Weather Assistant for all Cities",
    date: "Nov 2024 - Dec 2024",
    description:
      "Develop a functionality within the OpenAI assistant to fetch and display real-time weather information for a specified city using OpenAI's Assistant Tools and the OpenWeather API. This feature will allow the assistant to provide weather updates as part of the conversation, helping users plan activities like outdoor photo shoots or other weather-dependent events.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/images-1ae26.appspot.com/o/Global-Weather-Assistant-for-all-Cities.png?alt=media&token=887d9aef-81c0-45ce-96fa-084e2ed24c8e",
    tags: [
      "Node.js",
      "Express.js",
      "OpenAI API",
      "OpenAI Assistant API",
      "OpenWeather API",
      "JavaScript",
      "EJS Template Engine",
    ],
    category: "AI Automation",
    github:
      "https://github.com/usmanX191/Global-Weather-Assistant-for-all-Cities.git",
    webapp:
      "https://github.com/usmanX191/Global-Weather-Assistant-for-all-Cities.git",
  },
  // // {
  // //   id: 8,
  // //   title: "Face Recognition",
  // //   date: "Jan 2021",
  // //   description:
  // //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  // //   image:
  // //     "https://dontrepeatyourself.org/media/face-recognition-with-python-dlib-and-deep-learning_cezKZBj.png",
  // //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  // //   category: "machine learning",
  // //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // // },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
